module.exports = __webpack_public_path__ + "static/lessons-from-the-intersexed-89bedfd7578aa523bfce074b277d6973.jpg";